export const rot13 = (str: string): string => {
  const rotCharCode = (charCode: number, charCodeA: number) =>
    ((charCode - charCodeA + 13) % 26) + charCodeA;

  return str.replace(/[a-zA-Z]/g, match => {
    const charCode = match.charCodeAt(0);
    if (charCode >= 65 && charCode <= 90) {
      // uppercase letters
      return String.fromCharCode(rotCharCode(charCode, 65));
    } else if (charCode >= 97 && charCode <= 122) {
      // lowercase letters
      return String.fromCharCode(rotCharCode(charCode, 97));
    }
    return match;
  });
};

const checkForKeywords = (
  text: string,
  keywords: readonly string[],
): string[] =>
  keywords.filter(word => text.toLowerCase().includes(word.toLowerCase()));

const checkForKeywordsWithRot13 = (
  text: string,
  keywords: readonly string[],
): string[] =>
  rot13(keywords.join(','))
    .split(',')
    .filter(word => text.toLowerCase().includes(word.toLowerCase()));

export const getTextFromElements = (elements: NodeListOf<Element>): string[] =>
  Array.from(elements)
    .filter(el => el !== null)
    .map(el => el?.textContent?.trim() ?? '');

export const checkPageForKeywords = (
  keywords: readonly string[],
  isEncoded?: boolean,
): string[] => {
  const url = window.location.href;
  const title = document.title.trim();
  const content = getTextFromElements(document.querySelectorAll('p'));
  const links = getTextFromElements(document.querySelectorAll('a'));

  const text = `${url} ${title} ${content.join(' ')} ${links.join(' ')}`;

  return isEncoded
    ? checkForKeywordsWithRot13(text, keywords)
    : checkForKeywords(text, keywords);
};
